import { gql } from "@apollo/client";

const GET_ANALYTICS = gql`
  query($studentId: ID!) {
    get_student_analytics(studentId: $studentId) {
     message
     value
     data{
       total_no_of_all_class_visits
       total_no_of_all_lesson_views
       total_no_of_time_spent_on_lessons
       lessons{
         no_of_lesson_views
         time_spent_on_lesson
          lesson{
           lesson_name
         }
       }
     }
    }
  }
`;


const GET_CLASS_ANALYTICS = gql`
  query($classId: ID!) {
    student_class_analytics(classId: $classId) {
     message
     value
     data{
       total_no_of_class_visits
       total_time_spent_on_lessons
       average_time_spent_on_lessons 
       total_no_of_submitted_assessments
       total_no_of_class_comments
     }
    }
  }
`;


export { GET_ANALYTICS, GET_CLASS_ANALYTICS };